/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import "../../CSS/DataModal.css";

const DeleteAssetConfirmationModal = ({ show, title, loading, itemDescription, parentOrgNames, onConfirmDelete, onCancelClick }) => {
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');

    const requiredOrgNames = parentOrgNames || [];

    useEffect(() => {
        if (show) {
            setInputValue('');
            setError('');
        }
    }, [show]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        if (error) setError('');
    };

    const handleCancel = (e) => {
        onCancelClick && onCancelClick(e);
        setInputValue('');
        setError('');
    };

    const handleSubmit = () => {
        const expected = requiredOrgNames.join(', ').trim();
        const typed = inputValue.trim();

        const matches = typed.length > 0 && typed === expected;

        if (!matches) {
            setError(`That doesn't match. Type ${requiredOrgNames.length > 1 ? "all of the following names, separated by commas" : "the following name"} to confirm: "${requiredOrgNames.join(', ')}"`);
            return;
        }
        onConfirmDelete && onConfirmDelete();
    };

    if (!show) return null;

    return (
        <div className="modal" style={{ display: show ? "block" : "none" }}>
            <div
                className="modal-wrapper"
                style={{
                    transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                    opacity: show ? '1' : '0'
                }}
            >
                <div className="modal-header">
                    <h3>{title || "Delete Asset"}</h3>
                    <span className="close-modal-btn" onClick={handleCancel}>×</span>
                </div>

                <div className="modal-body">
                    {loading ?
                        <div className='centered' style={{ minHeight: '300px', alignItems: 'center' }}><Spinner animation="border" variant="dark" /></div>
                        :
                        <>
                            <p>
                                This will permanently delete {itemDescription || "the selected item(s)"}.
                                To confirm, type {requiredOrgNames.length > 1 ? "the following organization names, separated by commas" : "the following organization name"} below: <b>{requiredOrgNames.join(', ')}</b>
                            </p>
                            <div className="form-row form-data">
                                <p className="label-text">Parent Organization : </p>
                                <input
                                    type="text"
                                    className="input-text input-half"
                                    placeholder="Enter parent organization name"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                />
                            </div>
                            {error && (
                                <p className="error-text">{error}</p>
                            )}
                        </>
                    }
                </div>

                <div className="modal-footer">
                    <button className="secondary-btn btn-small" onClick={handleCancel}>Cancel</button>
                    <button className="primary-btn btn-small" disabled={loading} onClick={handleSubmit}>Delete</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteAssetConfirmationModal;
